import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SessionEventService {
  private sessionInvalid$ = new Subject<void>();

  public notifySessionInvalid(): void {
    this.sessionInvalid$.next();
  }

  public get onSessionInvalid() {
    return this.sessionInvalid$.asObservable();
  }
}